var map = {
	"./Havilah Presentation-1.jpg": 8781,
	"./Havilah Presentation-10.jpg": 7846,
	"./Havilah Presentation-2.jpg": 5501,
	"./Havilah Presentation-3.jpg": 5326,
	"./Havilah Presentation-4.jpg": 6073,
	"./Havilah Presentation-5.jpg": 307,
	"./Havilah Presentation-6.jpg": 5279,
	"./Havilah Presentation-7.jpg": 4108,
	"./Havilah Presentation-8.jpg": 3614,
	"./Havilah Presentation-9.jpg": 7994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8065;